<template>
  <el-button-group>
    <el-tooltip class="item" effect="dark" content="Редактировать" placement="top-start">
      <el-button type="primary" @click="$emit('toggle')">
        <el-icon>
          <EditPen />
        </el-icon>
        <span v-if="mobileScreen">Редактировать</span>
      </el-button>
    </el-tooltip>
    <el-tooltip class="item" effect="dark" content="Удалить" placement="top-start">
      <el-button @click="$emit('remove')" type="danger">
        <el-icon>
          <Delete />
        </el-icon>
        <span v-if="mobileScreen">Удалить</span>
      </el-button>
    </el-tooltip>
  </el-button-group>
</template>

<script lang="ts" setup>
interface IProps {
  mobileScreen?: boolean
  showDelButton?: boolean
}

const props = withDefaults(defineProps<IProps>(), {
  mobileScreen: false,
  showDelButtont: false,
})
interface IEmits {
  (e: 'toggle'): void
  (e: 'remove'): void
}

const emit = defineEmits<IEmits>()
</script>

<style lang="sass" scoped></style>
